export const UPDATE_UNAWARDED_SHIFTLINES_REPORT = 'UPDATE_UNAWARDED_SHIFTLINES_REPORT';
export const RESET_UNAWARDED_SHIFTLINES_REPORT = 'RESET_UNAWARDED_SHIFTLINES_REPORT';
